// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2FhtZ","title":"styles_title__2hRhE","description":"styles_description__3E4Cp","cards":"styles_cards__1Z3cQ"};